export class FindAllFormsError {
  public static readonly type = '[Project/Form/List] FindAllFormsError';
  constructor(public readonly error: Error) {}
}
